import _ from 'lodash'
import uuid from 'uuid/v4'
import api from './response/api'
import auth from './response/auth'
import form from './response/form'
import http from './response/http'

export default _.merge(
  {
    methods: {
      raiseErrorMessage(response) {
        if (this.raiseFormErrorMessage(response)) {
          return true
        }
        if (this.raiseApiErrorMessage(response)) {
          return true
        }
        if (this.raiseHttpError(response)) {
          return true
        }
        return false
      },
      isResponseError(response) {
        return this.isResponseWithFormError(response)
          || this.isApiResponseError(response)
          || this.isHttpError(response)
      },
      getActualResponse(response) {
        return _.has(response, 'response')
          ? _.get(response, 'response')
          : response
      },
      generateUniqueRouteQuery() {
        return {_t: uuid().substr(-12)}
      }
    },
  },
  auth,
  form,
  api,
  http
)
